import { RolloverOptions } from '../../../options/calculations/rollover/rollover.options';
import { RolloverShareholderOptions } from '../../../options/calculations/rollover/rollover-shareholder.options';
import {
  RolloverSharesClassShareholderDistributionOptions,
} from '../../../options/calculations/rollover/rollover-shares-class-shareholder-distribution.options';
import { RolloverSharesClassOptions } from '../../../options/calculations/rollover/rollover-shares-class.options';
import {
  RolloverNonShareConsiderationOptions,
} from '../../../options/calculations/rollover/rollover-non-share-consideration.options';
import {
  RolloverPropertyTransferredSection84_1Options,
} from '../../../options/calculations/rollover/rollover-property-transferred-section-84_1.options';
import {
  RolloverPropertyTransferredNonShareConsiderationOptions,
} from '../../../options/calculations/rollover/rollover-property-transferred-non-share-consideration.options';
import {
  RolloverPropertyTransferredSharesClassOptions,
} from '../../../options/calculations/rollover/rollover-property-transferred-shares-class.options';
import {
  RolloverPropertyTransferredOptions,
} from '../../../options/calculations/rollover/rollover-property-transferred.options';
import { RolloverPropertyTypeEnum } from '../../../enums/calculations/rollover/rollover-property-type.enum';
import {
  RolloverPropertyRevenueTypeEnum,
} from '../../../enums/calculations/rollover/rollover-property-revenue-type.enum';
import { RolloverFormOptions } from '../../../options/calculations/rollover/rollover-form.options';
import {
  RolloverRequiredInformationPropertiesTransferredOptions,
} from '../../../options/calculations/rollover/rollover-required-information-properties-transferred.options';
import {
  RolloverRequiredInformationOptions,
} from '../../../options/calculations/rollover/rollover-required-information.options';
import { CalculationKeynameEnum } from '../../../enums/calculations/calculation-keyname.enum';
import { MoneyUtil } from '../../../utils/money.util';
import { v4 as uuid } from 'uuid';
import { TypeUtil } from '../../../utils/type.util';
import { CalculationDate } from '../../../models/calculation.date';


const shareholder1Options: RolloverShareholderOptions = TypeUtil.create(RolloverShareholderOptions, {
  id: uuid(),
  title: 'Horacio Arruda',
  isSeller: false,
});

const shareholder2Options: RolloverShareholderOptions = TypeUtil.create(RolloverShareholderOptions, {
  id: uuid(),
  title: 'François Legault',
  isSeller: true,
});

const shareholder3Options: RolloverShareholderOptions = TypeUtil.create(RolloverShareholderOptions, {
  id: uuid(),
  title: 'Christian Dubé',
  isSeller: false,
});

const sharesClass1ShareholdersDistribution1Options: RolloverSharesClassShareholderDistributionOptions = TypeUtil.create(RolloverSharesClassShareholderDistributionOptions, {
  shareholderId: shareholder1Options.id,
  numberOfSharesOwned: 1000,
  adjustedCostBase: MoneyUtil.dollarsToCent('800.00'),
  fairMarketValue: MoneyUtil.dollarsToCent('600.00'),
  paidUpCapital: MoneyUtil.dollarsToCent('400.00'),
});

const sharesClass1ShareholdersDistribution2Options: RolloverSharesClassShareholderDistributionOptions = TypeUtil.create(RolloverSharesClassShareholderDistributionOptions, {
  shareholderId: shareholder2Options.id,
  numberOfSharesOwned: 400,
  adjustedCostBase: MoneyUtil.dollarsToCent('600.00'),
  fairMarketValue: MoneyUtil.dollarsToCent('800.00'),
  paidUpCapital: MoneyUtil.dollarsToCent('1 000.00'),
});

const sharesClass1Options: RolloverSharesClassOptions = TypeUtil.create(RolloverSharesClassOptions, {
  id: uuid(),
  title: 'A',
  isRightToResidual: false,
  isRightToVote: false,
  isRightToParticipate: false,
  redemptionValue: MoneyUtil.dollarsToCent('1.00'),
  shareholdersDistribution: [sharesClass1ShareholdersDistribution1Options, sharesClass1ShareholdersDistribution2Options],
});

const sharesClass2ShareholdersDistribution1Options: RolloverSharesClassShareholderDistributionOptions = TypeUtil.create(RolloverSharesClassShareholderDistributionOptions, {
  shareholderId: shareholder1Options.id,
  numberOfSharesOwned: 200,
  adjustedCostBase: MoneyUtil.dollarsToCent('300.00'),
  fairMarketValue: MoneyUtil.dollarsToCent('400.00'),
  paidUpCapital: MoneyUtil.dollarsToCent('500.00'),
});

const sharesClass2Options: RolloverSharesClassOptions = TypeUtil.create(RolloverSharesClassOptions, {
  id: uuid(),
  title: 'B',
  isRightToResidual: false,
  isRightToVote: true,
  isRightToParticipate: false,
  redemptionValue: MoneyUtil.dollarsToCent('1.00'),
  shareholdersDistribution: [sharesClass2ShareholdersDistribution1Options],
});

const sharesClass3ShareholdersDistribution1Options: RolloverSharesClassShareholderDistributionOptions = TypeUtil.create(RolloverSharesClassShareholderDistributionOptions, {
  shareholderId: shareholder3Options.id,
  numberOfSharesOwned: 2000,
  adjustedCostBase: MoneyUtil.dollarsToCent('1 500.00'),
  fairMarketValue: MoneyUtil.dollarsToCent('1 000.00'),
  paidUpCapital: MoneyUtil.dollarsToCent('500.00'),
});

const sharesClass3Options: RolloverSharesClassOptions = TypeUtil.create(RolloverSharesClassOptions, {
  id: uuid(),
  title: 'C',
  isRightToResidual: true,
  isRightToVote: true,
  isRightToParticipate: true,
  shareholdersDistribution: [sharesClass3ShareholdersDistribution1Options],
});

const sharesClass4ShareholdersDistribution1Options: RolloverSharesClassShareholderDistributionOptions = TypeUtil.create(RolloverSharesClassShareholderDistributionOptions, {
  shareholderId: shareholder3Options.id,
  numberOfSharesOwned: 856,
  adjustedCostBase: MoneyUtil.dollarsToCent('545.00'),
  fairMarketValue: MoneyUtil.dollarsToCent('265.00'),
  paidUpCapital: MoneyUtil.dollarsToCent('954.00'),
});

const sharesClass4ShareholdersDistribution2Options: RolloverSharesClassShareholderDistributionOptions = TypeUtil.create(RolloverSharesClassShareholderDistributionOptions, {
  shareholderId: shareholder2Options.id,
  numberOfSharesOwned: 111,
  adjustedCostBase: MoneyUtil.dollarsToCent('222.00'),
  fairMarketValue: MoneyUtil.dollarsToCent('333.00'),
  paidUpCapital: MoneyUtil.dollarsToCent('444.00'),
});

const sharesClass4Options: RolloverSharesClassOptions = TypeUtil.create(RolloverSharesClassOptions, {
  id: uuid(),
  title: 'D',
  isRightToResidual: true,
  isRightToVote: false,
  isRightToParticipate: true,
  shareholdersDistribution: [sharesClass4ShareholdersDistribution1Options, sharesClass4ShareholdersDistribution2Options],
});

const sharesClass5ShareholdersDistribution1Options: RolloverSharesClassShareholderDistributionOptions = TypeUtil.create(RolloverSharesClassShareholderDistributionOptions, {
  shareholderId: shareholder3Options.id,
  numberOfSharesOwned: 888,
  adjustedCostBase: MoneyUtil.dollarsToCent('777.00'),
  fairMarketValue: MoneyUtil.dollarsToCent('666.00'),
  paidUpCapital: MoneyUtil.dollarsToCent('555.00'),
});

const sharesClass5Options: RolloverSharesClassOptions = TypeUtil.create(RolloverSharesClassOptions, {
  id: uuid(),
  title: 'E',
  isRightToResidual: true,
  isRightToVote: true,
  isRightToParticipate: true,
  shareholdersDistribution: [sharesClass5ShareholdersDistribution1Options],
});

export const nonShareConsideration1Options: RolloverNonShareConsiderationOptions = TypeUtil.create(RolloverNonShareConsiderationOptions, {
  id: uuid(),
  title: 'Billet à payer',
});

export const nonShareConsideration2Options: RolloverNonShareConsiderationOptions = TypeUtil.create(RolloverNonShareConsiderationOptions, {
  id: uuid(),
  title: 'Hypothèque',
});

const propertyTransferred1Section84_1Options: RolloverPropertyTransferredSection84_1Options = TypeUtil.create(RolloverPropertyTransferredSection84_1Options, {
  areTransferredSharesCanadianShares: true,
  areTransferredSharesCapitalPropertyForTheSeller: true,
  isSellerAnIndividualOrATrust: true,
  isSellerACanadianResident: true,
  isBuyerACorporation: true,
  areBuyerAndSellerAtArmsLength: true,
  isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction: true,
  wereSharesAcquiredAfter1971: false,
  fairMarketValueOnValuationDayOfTransferredShares: MoneyUtil.dollarsToCent('0.00'),
  actualCostOnJanuary1972OfTransferredShares: MoneyUtil.dollarsToCent('0.00'),
  receivedDividendChoice83OnTransferredShares: MoneyUtil.dollarsToCent('0.00'),
  capitalGainsOnTheShareDeclaredAfter1984: MoneyUtil.dollarsToCent('0.00'),
  sellingFees: MoneyUtil.dollarsToCent('0.00'),
});

const propertyTransferred1NonShareConsideration1Options: RolloverPropertyTransferredNonShareConsiderationOptions = TypeUtil.create(RolloverPropertyTransferredNonShareConsiderationOptions, {
  nonShareConsiderationId: nonShareConsideration1Options.id,
  // title: nonShareConsideration1Options.title,
  amountOfNonShareConsideration: MoneyUtil.dollarsToCent('1 000.00'),
});

const propertyTransferred1NonShareConsideration2Options: RolloverPropertyTransferredNonShareConsiderationOptions = TypeUtil.create(RolloverPropertyTransferredNonShareConsiderationOptions, {
  nonShareConsiderationId: nonShareConsideration2Options.id,
  // title: nonShareConsideration2Options.title,
  amountOfNonShareConsideration: MoneyUtil.dollarsToCent('2 000.00'),
});

const propertyTransferred1SharesClass1Options: RolloverPropertyTransferredSharesClassOptions = TypeUtil.create(RolloverPropertyTransferredSharesClassOptions, {
  sharesClassId: sharesClass1Options.id,
  numberOfShares: 500,
  fairMarketValue: MoneyUtil.dollarsToCent('10 000.00'),
});

const propertyTransferred1SharesClass2Options: RolloverPropertyTransferredSharesClassOptions = TypeUtil.create(RolloverPropertyTransferredSharesClassOptions, {
  sharesClassId: sharesClass2Options.id,
  numberOfShares: 1200,
  fairMarketValue: MoneyUtil.dollarsToCent('7 000.00'),
});

const propertyTransferred1Options: RolloverPropertyTransferredOptions = TypeUtil.create(RolloverPropertyTransferredOptions, {
  id: uuid(),
  title: 'Actions',
  fairMarketValue: MoneyUtil.dollarsToCent('20 000.00'),
  isVerifyPropertyEligibility: false,
  isRealEstate: false,
  isNonResident: false,
  isCustomerAccount: false,
  //isArticle22: undefined,
  //isCashAccounting: undefined,
  agreedAmount: MoneyUtil.dollarsToCent('20 000.00'),
  adjustedCostBase: MoneyUtil.dollarsToCent('25 000.00'),
  //underpreciatedCapitalCostAfterAdditionsAndDispositions: undefined,
  //capitalCostOfAllTheProperties: undefined,
  isCalculateNumberOfPreferredShares: false,
  isSameSharesConditions: false,
  isInternalRollOver: false,
  isDoPerfectRollover: false,
  isCalculateMaximumNonShareConsideration: false,
  //isDepreciablePropertyUsedForInvestment: undefined,
  //isDepreciablePropertyTheLastOfItsCategory: undefined,
  paidUpCapitalOfTransferredShares: MoneyUtil.dollarsToCent('200.00'),
  areShares: true,
  propertyType: RolloverPropertyTypeEnum.nonDepreciableProperty,
  section84_1: propertyTransferred1Section84_1Options,
  nonShareConsiderations: [propertyTransferred1NonShareConsideration1Options, propertyTransferred1NonShareConsideration2Options],
  sharesClasses: [propertyTransferred1SharesClass1Options, propertyTransferred1SharesClass2Options],
});

const propertyTransferred2SharesClass1Options: RolloverPropertyTransferredSharesClassOptions = TypeUtil.create(RolloverPropertyTransferredSharesClassOptions, {
  sharesClassId: sharesClass1Options.id,
  numberOfShares: 200,
  fairMarketValue: MoneyUtil.dollarsToCent('2000.00'),
});

const propertyTransferred2SharesClass2Options: RolloverPropertyTransferredSharesClassOptions = TypeUtil.create(RolloverPropertyTransferredSharesClassOptions, {
  sharesClassId: sharesClass3Options.id,
  numberOfShares: 321,
  fairMarketValue: MoneyUtil.dollarsToCent('1000.00'),
});

const propertyTransferred2NonShareConsideration1Options: RolloverPropertyTransferredNonShareConsiderationOptions = TypeUtil.create(RolloverPropertyTransferredNonShareConsiderationOptions, {
  nonShareConsiderationId: nonShareConsideration1Options.id,
  // title: nonShareConsideration1Options.title,
  amountOfNonShareConsideration: MoneyUtil.dollarsToCent('5 000.00'),
});

const propertyTransferred2Options: RolloverPropertyTransferredOptions = TypeUtil.create(RolloverPropertyTransferredOptions, {
  id: uuid(),
  title: 'Achalandage',
  fairMarketValue: MoneyUtil.dollarsToCent('8 000.00'),
  isRealEstate: false,
  isNonResident: false,
  isCustomerAccount: false,
  agreedAmount: MoneyUtil.dollarsToCent('8 000.00'),
  adjustedCostBase: MoneyUtil.dollarsToCent('28 000.00'),
  underpreciatedCapitalCostAfterAdditionsAndDispositions: MoneyUtil.dollarsToCent('13 000.00'),
  isVerifyPropertyEligibility: false,
  isCalculateNumberOfPreferredShares: false,
  isSameSharesConditions: false,
  isInternalRollOver: false,
  isDoPerfectRollover: false,
  isCalculateMaximumNonShareConsideration: false,
  propertyRevenueType: RolloverPropertyRevenueTypeEnum.companyRevenue,
  isDepreciablePropertyTheLastOfItsCategory: true,
  areShares: false,
  propertyType: RolloverPropertyTypeEnum.depreciableProperty,
  nonShareConsiderations: [propertyTransferred2NonShareConsideration1Options],
  sharesClasses: [propertyTransferred2SharesClass1Options, propertyTransferred2SharesClass2Options],
});

const propertyTransferred3NonShareConsideration1Options: RolloverPropertyTransferredNonShareConsiderationOptions = TypeUtil.create(RolloverPropertyTransferredNonShareConsiderationOptions, {
  nonShareConsiderationId: nonShareConsideration2Options.id,
  // title: nonShareConsideration2Options.title,
  amountOfNonShareConsideration: MoneyUtil.dollarsToCent('350.00'),
});

const propertyTransferred3SharesClass1Options: RolloverPropertyTransferredSharesClassOptions = TypeUtil.create(RolloverPropertyTransferredSharesClassOptions, {
  sharesClassId: sharesClass3Options.id,
  numberOfShares: 200,
  fairMarketValue: MoneyUtil.dollarsToCent('200.00'),
});

const propertyTransferred3SharesClass2Options: RolloverPropertyTransferredSharesClassOptions = TypeUtil.create(RolloverPropertyTransferredSharesClassOptions, {
  sharesClassId: sharesClass4Options.id,
  numberOfShares: 360,
  fairMarketValue: MoneyUtil.dollarsToCent('360.00'),
});

const propertyTransferred3Options: RolloverPropertyTransferredOptions = TypeUtil.create(RolloverPropertyTransferredOptions, {
  id: uuid(),
  title: 'Stock',
  fairMarketValue: MoneyUtil.dollarsToCent('1110.00'),
  isRealEstate: false,
  isNonResident: false,
  isCustomerAccount: false,
  agreedAmount: MoneyUtil.dollarsToCent('550.00'),
  adjustedCostBase: MoneyUtil.dollarsToCent('550.00'),
  isVerifyPropertyEligibility: false,
  isCalculateNumberOfPreferredShares: false,
  isInternalRollOver: false,
  isDoPerfectRollover: true,
  isCalculateMaximumNonShareConsideration: true,
  areShares: false,
  propertyType: RolloverPropertyTypeEnum.inventoryProperty,
  nonShareConsiderations: [propertyTransferred3NonShareConsideration1Options],
  sharesClasses: [propertyTransferred3SharesClass1Options, propertyTransferred3SharesClass2Options],
});

const form: RolloverFormOptions = {
  sellerNameForForm: '',
  isSellerAPerson: false,
  isSellerACorporation: false,
  isSellerATrust: false,
  sellerSocialSecurityNumber: '',
  sellerBusinessNumber: '',
  sellerIdentificationNumber: '',
  sellerQuebecEntrepriseNumber: '',
  sellerTrustAccountNumber: '',
  sellerOfficeNumber: '',
  sellerAdressNumber: '',
  sellerStreetName: '',
  sellerTownName: '',
  sellerProvinceName: '',
  sellerPostalCode: '',
  sellerTaxationYearStart: new CalculationDate(),
  sellerTaxationYearEnd: new CalculationDate(),
  sellerTaxServicesOffice: '',
  isThereACoowner: false,
  coownerName: '',
  coownerGovernmentalNumber: '',
  coownerAdress: '',
  coownerPostalCode: '',
  coownerTaxServicesOffice: '',
  buyerCorporationNameForForm: '',
  buyerBusinessNumber: '',
  buyerIdentificationNumber: '',
  buyerQuebecEnterpriseNumber: '',
  buyerOfficeNumber: '',
  buyerAdressNumber: '',
  buyerStreetName: '',
  buyerTownName: '',
  buyerProvinceName: '',
  buyerPostalCode: '',
  buyerTaxationYearStart: new CalculationDate(),
  buyerTaxationYearEnd: new CalculationDate(),
  buyerTaxServicesOffice: '',
  buyerResourcePerson: '',
  buyerResourcePersonPhone: '',
};

const propertyTransferredRequiredInformation1: RolloverRequiredInformationPropertiesTransferredOptions = TypeUtil.create(RolloverRequiredInformationPropertiesTransferredOptions, {
  propertyTransferredId: '',
  areShares: false,
  sellingSharesCorporationName: '',
  sellingSharesCorporationBusinessNumber: '',
  sellingSharesCorporationRCNumber: '',
  sellingSharesCorporationIdentificationNumber: '',
  sellingSharesCorporationQuebecEnterpriseNumber: '',
});

const requiredInformation: RolloverRequiredInformationOptions = TypeUtil.create(RolloverRequiredInformationOptions, {
  sellingDate: new CalculationDate(),
  isWrittenAgreement: false,
  isPriceAdjustmentClause: false,
  isOtherShareholder: false,
  isNonArmLengthCorporation: false,
  isTransferToBuyerCorporation: false,
  isNonResident: false,
  isCapitalProperty: false,
  isAssessmentDay: false,
  isAssessmentDayAndNonArmLength: false,
  isAssessmentDayAnd83_1: false,
  isFairMarketValueOnAssessmentDay: false,
  isOfficialReport: false,
  isChoice_26_7: false,
  signatureDate: new CalculationDate(),
  isTheAgreedAmountDifferentForQuebecRolloverForm: false,
  isTheAgreedAmountForQuebecRolloverFormDifferentBecauseOfCost: false,
  reasonForDifferentAgreedAmountForQuebecRolloverForm: '',
  isThe85LIRChoiceBeenMade: false,
  isThirdParagraphOfSection522ChoiceBeenMade: false,
  is13_21_2ApplicableForQuebecRolloverForm: false,
  nonArmLengthForQuebecRolloverForm: false,
  transferToBuyerCorporationForQuebecRolloverForm: false,
  depreciationCategory44: '',
  uCCBeforeTransfer44: MoneyUtil.dollarsToCent('0.00'),
  depreciationCategory45: '',
  uCCBeforeTransfer45: MoneyUtil.dollarsToCent('0.00'),
  depreciationCategory46: '',
  uCCBeforeTransfer46: MoneyUtil.dollarsToCent('0.00'),
  depreciationCategory47: '',
  uCCBeforeTransfer47: MoneyUtil.dollarsToCent('0.00'),
  depreciationCategory48: '',
  uCCBeforeTransfer48: MoneyUtil.dollarsToCent('0.00'),
  nameOfTransferOrAuthorizedSignee: '',
  nameOfTransferOrAuthorizedSigneeForTheTransferee: '',
  propertiesTransferred: [propertyTransferredRequiredInformation1],
});

export const rolloverScenario1Options: RolloverOptions = TypeUtil.create(RolloverOptions, {
  calculationKeyname: CalculationKeynameEnum.Rollover,
  signatureDate: new CalculationDate(),
  productionDeadline: new CalculationDate(),
  buyerCorporation: 'Omicron inc.',
  isThereRolloverForm: false,
  // requiredInformation: requiredInformation,
  // rolloverFormOptions: form,
  sharesClasses: [sharesClass1Options, sharesClass2Options, sharesClass3Options, sharesClass4Options, sharesClass5Options],
  propertiesTransferred: [propertyTransferred1Options, propertyTransferred2Options, propertyTransferred3Options],
  shareholders: [shareholder1Options, shareholder2Options, shareholder3Options],
  nonShareConsiderations: [nonShareConsideration1Options, nonShareConsideration2Options],
});
